import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useChat } from '../../contexts/ChatContext';
import { apiService } from '../../services/api';
import './ChatControls.css';

const ChatControls = () => {
  const { authData } = useAuth();
  const { clearMessages, connectionStatus, sendChatMessage } = useChat();
  const [chatInput, setChatInput] = useState('');

  const handleSendChatMessage = async (e) => {
    e.preventDefault();
    if (!chatInput.trim()) return;
    
    try {
      const success = await sendChatMessage(chatInput.trim());
      if (success) {
        setChatInput('');
      } else {
        alert('Failed to send chat message. Please try again.');
      }
    } catch (error) {
      console.error('❌ Failed to send chat message:', error);
      alert(`Failed to send chat message: ${error.message}`);
    }
  };

  const sendTestRuntimeData = async () => {
    try {
      console.log('🧪 Testing runtime data send...');
      
      if (!authData?.sessionId) {
        console.error('❌ No session found for runtime data test');
        return;
      }

      const testData = {
        components: [
          {
            hash: "test_profile_btn",
            text: "Edit Profile Button",
            componentType: "button",
            isClickable: true,
            children: []
          },
          {
            hash: "test_settings_btn", 
            text: "Settings Button",
            componentType: "button",
            isClickable: true,
            children: []
          }
        ],
        deviceId: "test_device_001",
        currentRoute: "Home"
      };

      const response = await apiService.sendRuntimeData(authData.sessionId, testData);
      console.log('✅ Test runtime data sent successfully:', response);
      alert('Runtime data sent successfully!');

    } catch (error) {
      console.error('❌ Failed to send test runtime data:', error);
      alert(`Failed to send runtime data: ${error.message}`);
    }
  };

  return (
    <div className="chat-controls">
      <div className="control-buttons">
        <button onClick={clearMessages} className="control-btn clear-btn">
          Clear Chat
        </button>
        <button onClick={sendTestRuntimeData} className="control-btn test-btn">
          Send Runtime Data
        </button>
      </div>
      
      {/* Chat Input Section */}
      <form onSubmit={handleSendChatMessage} className="chat-input-form">
        <input
          type="text"
          value={chatInput}
          onChange={(e) => setChatInput(e.target.value)}
          placeholder="Type a message to the AI..."
          className="chat-input"
          disabled={connectionStatus !== 'connected'}
        />
        <button 
          type="submit" 
          className="send-btn"
          disabled={!chatInput.trim() || connectionStatus !== 'connected'}
        >
          Send
        </button>
      </form>
      
      <div className="connection-status">
        <span className={`status-indicator ${connectionStatus}`}>
          {connectionStatus === 'connected' ? '●' : '○'}
        </span>
        <span className="status-text">{connectionStatus}</span>
      </div>
    </div>
  );
};

export default ChatControls; 